export default __webpack_public_path__ + "static/media/Rlot.a8d1ec52.jpg";